export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SELECT_PRODUCTS = 'SELECT_PRODUCTS'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const SET_PRODUCT_BY_ID = 'SET_PRODUCT_BY_ID'
export const SET_PRODUCT_PHOTO = 'SET_PRODUCT_PHOTO'
export const SET_BATCH_PRODUCTS = 'SET_BATCH_PRODUCTS'
